import { render, staticRenderFns } from "./ResultadoComponent.vue?vue&type=template&id=7a3ddcf3&"
import script from "./ResultadoComponent.vue?vue&type=script&lang=ts&"
export * from "./ResultadoComponent.vue?vue&type=script&lang=ts&"
import style0 from "./ResultadoComponent.vue?vue&type=style&index=0&id=7a3ddcf3&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports